import { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Age / gender for analysis and generation requests.
 *
 * **Must wait for auth to finish hydrating.** A cold load of
 * `/manual-create-stack` (bookmark, refresh, or Playwright `goto`) mounts this
 * hook before `auth.currentUser` is set. The previous one-shot read left
 * `loading` true forever in that window, so the form rendered only
 * "Loading..." and never recovered. `onAuthStateChanged` is the Firebase
 * answer: it fires once auth is known, including `null` for a guest.
 */
const useUserProfile = () => {
  const [userProfile, setUserProfile] = useState({ age: '', gender: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, async (user) => {
      try {
        if (user) {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          if (userDoc.exists()) {
            setUserProfile(userDoc.data());
          } else {
            setUserProfile({ age: '', gender: '' });
          }
        } else {
          setUserProfile({ age: '', gender: '' });
        }
      } finally {
        setLoading(false);
      }
    });
    return () => unsub();
  }, []);

  return { userProfile, loading };
};

export default useUserProfile;
